'use client';

import React, { useState, useEffect } from 'react';
import { ChevronDown, Calendar } from 'lucide-react';

export default function JumpToToday() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const jump = () => {
    const todayEl = document.querySelector('[data-today]');
    if (todayEl) {
      todayEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  if (!visible) return null;

  return (
    <button
      onClick={jump}
      className="md:hidden fixed bottom-20 right-4 z-50 flex items-center gap-1.5 px-3 py-2 bg-indigo-600 text-white rounded-full shadow-lg shadow-indigo-500/30 text-xs font-medium active:scale-95 transition-transform hover:bg-indigo-500"
      aria-label="Jump to Today"
    >
      <Calendar size={14} />
      오늘
      <ChevronDown size={14} />
    </button>
  );
}
